import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AtributoParametroEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class AtributoParametroDataService extends CrudService<AtributoParametroEntity>
{
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        protected httpClient: HttpClient
    )
    {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/AtributoParametro`;
    }

    public salvar = (atributo: AtributoParametroEntity) =>
        this.httpClient.put<AtributoParametroEntity>(this.url, atributo);

    public adicionar = (atributo: AtributoParametroEntity) =>
        this.httpClient.post<AtributoParametroEntity>(this.url, atributo);
}
